/* Ust menu cekmecesi: karartilan alana dokununca menuyu kapatir. */
(function () {
  function closeMenu(triesLeft) {
    var button = document.querySelector('.hamburger.opened');
    if (!button) return;
    button.click();
    if (triesLeft > 0) {
      window.setTimeout(function () {
        if (document.body.classList.contains('hamburder-opened')) closeMenu(triesLeft - 1);
      }, 250);
    }
  }
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.shape-overlays.is-opened')) closeMenu(5);
  });
})();
